/*!--------------------------------------------------------------------------
// <copyright file="GSS.widget.js" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var GSS;
(function (GSS) {
    var widget;
    (function (widget) {
        widget.attributeNames = {
            // <summary>The gss specific data attribute names.</summary>
            clientId: 'data-gss-clientid',
            componentId: 'data-gss-componentId',
            gssElementName: 'data-gss-name',
            ContentVersionIdName: 'data-gss-contverid',
            dashboardId: 'data-gss-dashboard-id',
            dashboardWidgetId: 'data-dashboard-widget-id',
            navigationState: 'data-gss-nav-state',
            dashboardWidgetHeight: "data-gss-widget-height",
            dashboardWidgetWidth: "data-gss-widget-width",
            omsClientCodeName: 'data-gss-oms-clientcodename',
            omsClientId: 'data-gss-oms-clientid',
            pageNumber: 'data-gss-page-num',
            pendingUserId: "data-gss-pending-user-id",
            projectId: "data-gss-projectId",
            ReadOnlyName: "data-gss-readonly",
            textVariantId: "data-gss-text-variant-id",
            userId: 'data-gss-userid',
            widgetCodeName: 'data-gss-widget-code-name',
            widgetStatus: 'data-gss-widget-status',
            menuItemAction: 'data-gss-menu-action',
            instrumentContentId: 'data-gss-instrcontid',
            participationId: 'data-gss-participationid',
            strengthsReportId: 'data-gss-strengthsreportid',
            memberId: 'data-gss-memberid'
        };
        widget.widgetErrorSettings = {
            // <summary>The settings for sending a widget error notification.</summary>
            errorParamName: '',
            subjectParamName: '',
            sourceUrl: '',
            notifyUrl: '../_Error/NotifyWidgetError',
            url: ''
        };
        widget.uniqueWidgetIdName = 'dashboardWidgetId';
        function getElementByGssName(name) {
            // <summary>Wraps a jQuery selector for getting an element based on a specific gss name data attribute value.</summary>
            // <param>The attribute value to select on.</param>
            return $('[' + widget.attributeNames.gssElementName + '="' + name + '"]');
        }
        widget.getElementByGssName = getElementByGssName;
        function getElementByGssTextVariantId(textVariantId) {
            // <summary>Wraps a jQuery selector for getting an element based on a specific gss text variant id data attribute value.</summary>
            // <param>The attribute value to select on.</param>
            return $('[' + widget.attributeNames.textVariantId + '="' + textVariantId + '"]');
        }
        widget.getElementByGssTextVariantId = getElementByGssTextVariantId;
        function getElementByGssPendingUserId(pendingUserId) {
            // <summary>Wraps a jQuery selector for getting an element based on a specific gss pending user id data attribute value.</summary>
            // <param>The attribute value to select on.</param>
            return $('[' + widget.attributeNames.pendingUserId + '="' + pendingUserId + '"]');
        }
        widget.getElementByGssPendingUserId = getElementByGssPendingUserId;
        function getElementByGssUserId(userId) {
            // <summary>Wraps a jQuery selector for getting an element based on a specific gss user id data attribute value.</summary>
            // <param>The attribute value to select on.</param>
            return $('[' + widget.attributeNames.userId + '="' + userId + '"]');
        }
        widget.getElementByGssUserId = getElementByGssUserId;
        function getWidgetContainer(dashboardWidgetId) {
            // <summary>Gets the widget container element for the specified unique widget identifier value.</summary>
            // <param name="dashboardWidgetId">The unique widget instance identifier.</param>
            return $('[' + widget.attributeNames.dashboardWidgetId + '="' + dashboardWidgetId + '"][' + widget.attributeNames.gssElementName + '="divWidget"]');
        }
        widget.getWidgetContainer = getWidgetContainer;
        function getWidgetContentElement(dashboardWidgetId) {
            // <summary>Gets the widget element that contains the main widget content.</summary>
            // <param name="dashboardWidgetId">The unique widget instance identifier.</param>
            return getWidgetContainer(dashboardWidgetId)
                .find('[' + widget.attributeNames.gssElementName + '="divWidgetContent"]').first();
        }
        widget.getWidgetContentElement = getWidgetContentElement;
        function getWidgetName(dashboardWidgetId) {
            // <summary>Gets the widget name based on the dashboard widget id value.</summary>
            // <param name="dashboardWidgetId">The unique widget instance identifier.</param>
            return getWidgetContainer(dashboardWidgetId).attr(widget.attributeNames.widgetCodeName);
        }
        widget.getWidgetName = getWidgetName;
        function getWidgetTitleElement(dashboardWidgetId) {
            // <summary>Gets the widget element that contains the title content.</summary>
            // <param name="dashboardWidgetId">The unique widget instance identifier.</param>
            return getWidgetContainer(dashboardWidgetId)
                .find('[' + widget.attributeNames.gssElementName + '="divWidgetHeader"]').first();
        }
        widget.getWidgetTitleElement = getWidgetTitleElement;
        function setWidgetProperties(notifyWidgetErrorUrl, subjectParamName, errorParamName) {
            // <summary>Sets the properties for the widget JavaScript library.</summary>
            // <param name="notifyWidgetErrorUrl">The server action that is responsible for sending the error notification.</param>
            // <param name="subjectParamName">The parameter name of the subject when notifying for a widget error.</param>
            // <param name="errorParamName">The error parameter name for the error message when notifying for a widget error.</param>
            widget.widgetErrorSettings.errorParamName = errorParamName;
            widget.widgetErrorSettings.subjectParamName = subjectParamName;
            widget.widgetErrorSettings.url = notifyWidgetErrorUrl;
        }
        widget.setWidgetProperties = setWidgetProperties;
    })(widget = GSS.widget || (GSS.widget = {}));
})(GSS || (GSS = {}));
//# sourceMappingURL=GSS.widget.js.map